// extracted by mini-css-extract-plugin
export default {"root":"BottomDrawer_root__9Afaa","topMarker":"BottomDrawer_topMarker__A3wBg"};